import React, { useContext, useState } from "react";

import { ContextNotificacoes } from "../../../services/notificacoes";

import { ReactComponent as Business } from "../../../assets/novosicones/notificacoes/business.svg";

import { useHistory } from "react-router-dom";

import { Spinner } from "../../StyledComponent";

import { verificaSeNoticiaExiste } from "../verificacaoSeNotificaoExiste";
// import { marcarNoticiaLido } from "../../../services/notificacoes";

const Videos = ({ tema, setNotificationsModal }) => {
  const {
    marcarNoticiaLido,
    atualizaNotificacoes,
    handleNotificationError,
  } = useContext(ContextNotificacoes);

  const NOTIFICATIONSNOTICIAS = JSON.parse(
    sessionStorage.getItem("notificationsNoticias")
  );

  const [noticiaSelecionada, setNoticiaSelecionada] = useState("");

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  function redirectToMeuImovel(empreendimentoIdSalesForce) {
    history.push({
      pathname: "/meu-imovel",
      state: {
        empreendimentoIdSalesForce,
      },
    });
  }

  async function marcarNoticiaComoLido(id) {
    await marcarNoticiaLido(id);

    let temp = NOTIFICATIONSNOTICIAS.filter((noticia) => noticia.Id != id);
    sessionStorage.setItem("notificationsNoticias", JSON.stringify(temp));

    await atualizaNotificacoes();
  }

  const handleVisualizar = async (
    id,
    empreendimentoIdSalesForce,
    noticiaId
  ) => {
    marcarNoticiaComoLido(id);

    if (
      (await verificaSeNoticiaExiste(empreendimentoIdSalesForce, noticiaId))
        ?.length > 0
    ) {
      redirectToMeuImovel(empreendimentoIdSalesForce);
      setLoading(false);
      setNotificationsModal(false);
    } else {
      setLoading(false);
      setNotificationsModal(false);
      handleNotificationError();
    }
  };

  let checkIfNewVideo = [];

  checkIfNewVideo = NOTIFICATIONSNOTICIAS.filter((item) => {
    return !item.Visualisado;
  });

  if (checkIfNewVideo.length == 0) return null;

  return (
    <div className="notifications__item">
      <span
        className="notifications__item__title"
        style={{ color: tema.primaryColor }}
      >
        Notícias:
      </span>

      {NOTIFICATIONSNOTICIAS?.map((noticia) => {
        return (
          <div className="centralized-space-between" key={noticia.Id}>
            <div className="centralized">
              <span style={{ width: "24px", height: "24px", display: "block" }}>
                <Business style={{ fill: tema.primaryColor }} />
              </span>
              <p
                className="notifications__item__description"
                style={{ color: "#454545" }}
              >
                Adicionamos a notícia <b>{noticia.Titulo}</b> sobre o seu
                imóvel. Clique em Visualizar e confira!
              </p>
            </div>
            {loading && noticiaSelecionada == noticia?.IdSalesForce ? (
              <Spinner />
            ) : (
              <a
                style={{ color: tema.primaryColor, cursor: "pointer" }}
                onClick={() => {
                  setLoading(true);
                  setNoticiaSelecionada(noticia?.IdSalesForce);
                  handleVisualizar(
                    noticia.Id,
                    noticia.EmpreendimentoIdSalesForce,
                    noticia.IdSalesForce
                  );
                }}
              >
                VISUALIZAR
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Videos;
